"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("homeContrat", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: require("./homeContrat.html"),
    controller: function controller($scope, $http, $session, tlTableUtils, $translate, $applications) {
      $scope.appPath = $applications.getCurrentAppPath();
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/home/infoIntra/contrat/homeContrat.js
// module id = 2789
// module chunks = 13